module.exports = __webpack_public_path__ + "static/media/jenni-lee-win.044fe401.jpg";